import React, { memo, useState } from "react";
import {
  Container,
  InnterContent,
  Placeholder,
  PlayButton,
  ReactPlayerExtend,
} from "./styled";
interface Props {
  src: string;
  thumbnail?: string;
  playing?: boolean;
  ratio?: number;
  className?: string;
  justClick?: boolean;
  hideIcon?: boolean;
  fillPlaceholder?: boolean;
}

const Player: React.FC<Props> = ({
  src,
  thumbnail,
  ratio,
  className,
  justClick,
  hideIcon,
  fillPlaceholder,
}) => {
  const [playing, setPlaying] = useState(false);
  return (
    <Container
      playing={playing}
      thumbnail={thumbnail}
      ratio={ratio}
      className={className}
    >
      <InnterContent ratio={ratio} onClick={(): void => setPlaying(!playing)}>
        {!playing && (
          <Placeholder
            className="m-player-placeholder"
            onClick={(): void => {
              !justClick && setPlaying(true);
            }}
            hideIcon={hideIcon}
            fillPlaceholder={fillPlaceholder}
          >
            <PlayButton className="m-player-playbtn" />
          </Placeholder>
        )}
        <ReactPlayerExtend
          url={src}
          width="100%"
          height="100%"
          playing={!justClick && playing}
          onPause={(): void => {
            !justClick && setPlaying(false);
          }}
          onPlay={(): void => {
            !justClick && setPlaying(true);
          }}
        />
      </InnterContent>
    </Container>
  );
};

export default memo(Player);
